import {useLayoutQuery} from '../page-data/loaders/use-layout-query'

export function useUserCopilotAccess() {
  return useLayoutQuery().data.user.hasCopilotAccess
}
